export default {
  pageTitle: '活动报名',
  secendTitle: '请选择活动类型',
  radio1: '秒杀',
  radio2: '限时折扣',
  radio3: '跨店满减',
  radio4: '团购',
  radio5: '平台大促',
  radio6: '限时折扣',
  tips1: '请选择日期和场次',
  tips2: '请选择折扣或促销时长',
  dayRadio1: '1 天',
  dayRadio2: '2 天',
  dayRadio3: '3 天',
  dayRadio4: '5 天',
  dayRadio5: '7 天',
  dayRadio15: '15 天',
  dayRadio30: '30 天',
  day: '天',
  tips3: '如果报名申请通过，商品将在促销时段结束后自动恢复原价',
  tips4: '如果报名的促销时长为1天，商品同时会在当日的闪购频道中展示',
  application: '团购报名',
  tips5: '团购有效期',
  tips6: '成团人数',
  tips7: '团购超时时间(小时)',
  tips8: '期望开始时间',
  placeholder1: '时间选择器',
  activitylist: '减免额',
  statusDisplaylist1: '待审核',
  statusDisplaylist2: '尚未开始',
  statusDisplaylist3: '处理中',
  statusDisplaylist4: '已过期',
  statusDisplaylist5: '取消或拒绝',
  // --------
  bigpromotionstatus1: '待审核',
  bigpromotionstatus2: '待开始',
  bigpromotionstatus3: '进行中',
  bigpromotionstatus4: '已过期',
  bigpromotionstatus5: '取消或下架或拒绝',
  // --------
  columns1: '促销活动ID',
  columns2: '促销活动展示名',
  columns3: '创建时间',
  columns4: '促销类型',
  columns5: '促销内容',
  columns6: '开始时间',
  columns7: '状态',
  columns8: '已报名商品',
  columns9: '报名通过商品数',
  columns10: '选择',
  columnsPromotion1: '促销活动ID',
  columnsPromotion2: '促销活动展示名',
  columnsPromotion3: '创建时间',
  columnsPromotion4: 'CODE',
  columnsPromotion5: '开始时间',
  columnsPromotion6: '结束时间',
  columnsPromotion7: '状态',
  columnsPromotion8: '我已报名的商品',
  columnsPromotion9: '选择',
  error1: '请选择场次',
  error2: '请选择时长',
  error3: '请选择活动',
  joinNow: '立即报名',
  eventIntroduction: '活动介绍',
  eventRules: '活动规则',
  startSignUp: '开始报名',
  categoryTips: '品类限制',
  ratingLimit: '评分限制',
  discountRate: '优惠比例',
  productLimit: '限制商品数',
  notLimit: '不限制',
  detail: '详情',
  logisticsLimit: '物流限制',
  limitTips: '您是当前活动白名单店铺，不受前三项条件限制。',
  discountTips: '报名价格必须在最近历史最低价的基础上, 降价{num}%以上',
  promotionEvents: '大促活动',
  region: '国别',
  more: '查看更多',
  eventTime: '活动日期',

  ctgRuleTableLabel1: '部分品类规则',
  ctgRuleTableLabel2: '类目名',
  ctgRuleTableLabel3: '优惠比例(%)',
  ctgRuleTableLabel4: '评分限制',
  ctgRuleTableLabel5: '物流限制',
  modifyProductPrice: '调整大促商品价格',
  signUp: '报名'
}
